/** Parse column width from '250px' or number to number. */
export function parseColumnWidth(w) {
    if (w == null) return null;
    if (typeof w === 'number') return w;
    const match = String(w).match(/^(\d+(?:\.\d+)?)\s*px$/i);
    return match ? parseFloat(match[1], 10) : null;
}

/** Stable key for a column (used for resize state). */
export function getColumnKey(col, index) {
    return col.id ?? col.name ?? `col-${index}`;
}
